import Vue from 'vue';

import * as components from './components';
import Icon from './components/ui/icon.vue';
import plugins from './plugins';

plugins.init();

// Register global components
Vue.component('Icon', Icon);

// eslint-disable-next-line
new Vue({
    el: '#app',
    components: {
        ...components,
    },
    data: {
        menuOpen: false,
    },
});
